export default __webpack_public_path__ + "static/media/okxusdt.33947003.png";